// DEPENDENCIES
import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
// ICONS
import { FcFolder, FcOpenedFolder, FcFile, FcDocument } from 'react-icons/fc';
import { VscNewFile, VscNewFolder, VscEdit, VscTrash, VscCloudDownload } from 'react-icons/vsc';
import { FiTrash2, FiFilePlus, FiFolderPlus, FiEdit3, FiDownloadCloud } from 'react-icons/fi';
// COMPONENTS
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { Modal, Button, ProgressBar } from 'react-bootstrap';
import { FilePond, registerPlugin } from "react-filepond";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
// SERVICES AND HELPERS
import * as _ from 'lodash';
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import * as confirmModal from '../../redux/confirmModalRedux'
// ASSETS
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import constants from '../../constants/constants';
import { connect } from 'react-redux';
import { xor } from 'lodash';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const TransitionComponent = props => {
    const style = useSpring({
        from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
        to: {
            opacity: props.in ? 1 : 0,
            transform: `translate3d(${props.in ? 0 : 20}px,0,0)`
        }
    });

    return (
        <animated.div style={style}>
            <Collapse {...props} />
        </animated.div>
    );
};

const StyledTreeItem = withStyles(theme => ({
    iconContainer: {
        '& .close': {
            opacity: 0.3
        }
    },
    group: {
        marginLeft: 7,
        paddingLeft: 18,
        borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`
    }
}))(props => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

const useStyles = makeStyles({
    root: {
        height: '100%',
        flexGrow: 1,
        maxWidth: 460
    }
});

const RecursiveTreeComponent = props => {
    const { showConfirmModal, hideConfirmModal } = props;

    let {
        folderStructure,
        setFolderStructure,
        addNewFileFolder,
        renameFileFolder,
        deleteFileFolder
    } = props;

    const [showIndex, setShowIndex] = useState(-1);
    const [editObj, setEditObj] = useState({
        id: -1,
        name: '',
        type: ''
    });
    const [isMulti, setIsMulti] = useState(false)
    const classes = useStyles();
    const [file, setFile] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploaded, setUploaded] = useState(0);
    const [uploading, setUploading] = useState(0)
    const mainIconSize = 35;
    const actionIconSize = 20;

    const actions = [
        {
            id: 1,
            // icon: <VscNewFolder size={actionIconSize} />,
            icon: <FiFolderPlus size={actionIconSize} />,
            action: obj => setEditObj({ ...obj, type: 'Add Folder', name: '' }),
            folderOnly: true
        },
        {
            id: 2,
            // icon: <VscNewFile size={actionIconSize} />,
            icon: <FiFilePlus size={actionIconSize} />,
            action: obj => setEditObj({ ...obj, type: 'Add File', name: '' }),
            folderOnly: true
        },
        {
            id: 3,
            // icon: <VscEdit size={actionIconSize} />,
            icon: <FiEdit3 size={actionIconSize} />,
            action: obj => {
                if (obj.id === 99999) {
                    return;
                }
                setEditObj({
                    ...obj,
                    type: 'Rename ' + (obj.children ? 'Folder' : 'File')
                })
            },
            folderOnly: false
        },
        {
            id: 4,
            // icon: <VscTrash size={actionIconSize} />,
            icon: <FiTrash2 size={actionIconSize} />,
            action: obj => {
                if (obj.id === 99999) {
                    return;
                }
                showConfirmModal({
                    title: "Delete File/Folder",
                    text: "Are you sure you want to remove this file/folder?",
                    rightBtnText: "Confirm",
                    btnAction: () => {
                        deleteFileFolder(obj.id)
                            .then(res => {
                                let clonedFolderStructure = _.cloneDeep(folderStructure);
                                deleteRecursively(clonedFolderStructure.children, obj.id);

                                setFolderStructure(clonedFolderStructure);
                                hideConfirmModal();
                            })
                            .catch(ex => {
                                alert('Something went wrong');
                            });
                    }
                })


            },
            folderOnly: false
        }
    ];

    const deleteRecursively = (arr, id) => {
        for (let node of arr) {
            if (node.id === id) {
                let index = arr.findIndex(x => x.id === id);
                arr.splice(index, 1);
                return;
            }

            if (node.children) {
                deleteRecursively(node.children, id);
            }
        }

        return false;
    };

    const findNodeById = (arr, id) => {
        for (let node of arr) {
            if (node.id === id) return node;

            if (node.children) {
                let desiredNode = findNodeById(node.children, id);
                if (desiredNode) return desiredNode;
            }
        }

        return false;
    };

    const renameRecursively = (id, name) => {
        renameFileFolder(id, name).then(res => {
            let clonedFolderStructure = _.cloneDeep(folderStructure);

            let nodeFound = findNodeById(clonedFolderStructure.children, id);
            nodeFound.name = name;

            setFolderStructure(clonedFolderStructure);
            hideModalHandler();
        });
    };

    const addFolderHandler = (id, name) => {
        if (name === "") {
            return;
        }

        addNewFileFolder({
            parentId: id === 99999 ? null : id,
            name: name,
            file: null
        }).then(res => {
            let clonedFolderStructure = _.cloneDeep(folderStructure);

            let nodeFound = findNodeById([clonedFolderStructure], id);
            let newObj = {
                name: name,
                children: null,
                id: res.id,
                filePath: null
            };

            if (nodeFound.children === null) {
                nodeFound.children = [newObj];
            } else {
                let tempArr = sortByName([...nodeFound.children, newObj])
                nodeFound.children = tempArr;
            }

            setFolderStructure(clonedFolderStructure);
            hideModalHandler();
        });
    };

    const saveMultipleFiles = async (id) => {
        setUploading(fileList.length);
        setLoading(true);
        let index = 0;
        let savedFiles = [];

        for (const x of fileList) {
            await addNewFileFolder({
                parentId: id === 99999 ? null : id,
                name: x.name,
                file: x
            }).then(res => {
                setUploaded(++index);
                savedFiles.push({
                    name: x.name,
                    children: null,
                    id: res.id,
                    filePath: res.filePath
                });
            })
        }

        let clonedFolderStructure = _.cloneDeep(folderStructure);
        let nodeFound = findNodeById([clonedFolderStructure], id);

        if (nodeFound.children === null) {
            nodeFound.children = sortByName([...savedFiles]);
        } else {
            let tempArr = sortByName([...nodeFound.children, ...savedFiles]);
            nodeFound.children = tempArr;
        }
        setFolderStructure(clonedFolderStructure);
        hideModalHandler();
    }

    const addFileHandler = (id, name) => {
        if (name === "" || file.length === 0) {
            return;
        }
        setLoading(true);

        addNewFileFolder({
            parentId: id === 99999 ? null : id,
            name: name,
            file: file
        }).then(res => {
            let clonedFolderStructure = _.cloneDeep(folderStructure);

            let nodeFound = findNodeById([clonedFolderStructure], id);
            let newObj = {
                name: name,
                children: null,
                id: res.id,
                filePath: res.filePath
            };

            if (nodeFound.children === null) {
                nodeFound.children = [newObj];
            } else {
                let tempArr = sortByName([...nodeFound.children, newObj]);
                nodeFound.children = tempArr;
            }

            setFolderStructure(clonedFolderStructure);
            hideModalHandler();
        }).catch(ex => {

        })
    };

    const sortByName = (arr) => arr.sort((a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        if (a == b) return 0;
        return a < b ? -1 : 1;
        return 0;
    });

    const ActionLabelComponent = props => {
        return (
            <div className="label-block">
                <div
                    className="label-container"
                    onClick={() => {
                        if (editObj.id === props.id) {
                            return null;
                        }
                        setShowIndex(props.id);
                        setEditObj({
                            id: -1,
                            name: ''
                        });
                    }}
                >
                    <a>{props.name}</a>
                </div>
                {props.id == showIndex && (
                    <div className="actions-container" onClick={e => e.preventDefault()}>
                        {
                            <a onClick={() =>  window.open(constants.API_URL + props.filePath)}>
                                {/* <VscCloudDownload size={actionIconSize} /> */}
                                <FiDownloadCloud size={actionIconSize} />
                            </a>
                        }
                        {actions.filter(x => props.filePath ? x.folderOnly === false : true).map((action, index) => {
                            return (

                                <a key={index} onClick={() => action.action(props)}>
                                    {action.icon}
                                </a>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    };

    const renderTree = nodes => (
        <StyledTreeItem
            key={nodes.id}
            nodeId={nodes.id + ""}
            label={<ActionLabelComponent filePath={nodes.filePath} id={nodes.id} name={nodes.name} />}
        >
            {Array.isArray(nodes.children) || nodes.filePath === null ? (
                nodes.children ? nodes.children.length > 0 ? (
                    nodes.children.map(node => renderTree(node))
                ) : (
                    <></>
                ) : <></>
            ) : null}
        </StyledTreeItem>
    );

    const hideModalHandler = () => {
        setEditObj({
            id: -1,
            name: ''
        });
        setIsMulti(false);
        setUploading(0);
        setUploaded(0);
        setFileList([]);
        setFile([]);
        setLoading(false);
    };

    return (
        <div>
            <Modal show={editObj.id > 0} onHide={hideModalHandler}>
                <Modal.Header closeButton>
                    <Modal.Title>{editObj.type}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        editObj.type == 'Add File' && <>
                            <FilePond
                                allowMultiple={isMulti}
                                acceptedFileTypes={['image/*']}
                                labelIdle='Drag & Drop image or <span class="filepond--label-action">Browse</span>'
                                onupdatefiles={(file) => {
                                    if (file.length > 0) {
                                        let selectedFile = file[0].file;
                                        setEditObj({ ...editObj, name: selectedFile.name });
                                        setFile(selectedFile);
                                        setFileList(file.map(x => x.file))
                                    } else {
                                        setFile([]);
                                        setFileList([])
                                    }
                                }}
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isMulti}
                                        onChange={() => {
                                            setIsMulti(!isMulti)
                                        }}
                                        value="checkedB"
                                        color="primary"
                                    />
                                }
                                label="Multi File Upload"
                            />
                        </>

                    }
                    {
                        !isMulti && <input
                            className="form-control"
                            value={editObj.name}
                            onChange={e => setEditObj({ ...editObj, name: e.target.value })}
                        />
                    }
                </Modal.Body>
                {
                    uploading > 0 && <div className="container">
                        <strong>{uploaded} / {uploading} uploaded.</strong>
                    </div>
                }
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideModalHandler}>
                        Close
                    </Button>
                    <button
                        disabled={loading}
                        className="btn btn-success mr-2"
                        variant="primary"
                        onClick={() => {
                            if (['Rename File', 'Rename Folder'].includes(editObj.type)) {
                                renameRecursively(editObj.id, editObj.name);
                            } else if (editObj.type == 'Add Folder') {
                                addFolderHandler(editObj.id, editObj.name);
                            } else {
                                if (isMulti) {
                                    saveMultipleFiles(editObj.id);
                                } else {
                                    addFileHandler(editObj.id, editObj.name);
                                }
                            }
                        }}
                    >
                        {loading ? "Please wait..." : "Save Changes"}
                    </button>
                </Modal.Footer>
            </Modal>
            <TreeView
                className={classes.root}
                defaultExpanded={['1']}
                defaultCollapseIcon={<FcOpenedFolder size={mainIconSize} />}
                defaultExpandIcon={<FcFolder size={mainIconSize} />}
                defaultEndIcon={<FcDocument size={mainIconSize} />}
            >
                {renderTree(folderStructure)}
            </TreeView>
        </div>
    );
};

export default connect(null, confirmModal.actions)(RecursiveTreeComponent);